export interface RouteHandle {
  label?: string;
  title?: string;
  protected?: boolean;
  icon?: string;
}

export interface SubNavItem {
  href: string;
  label: string;
  icon?: string;
}

export interface NavItem {
  href: string;
  label: string;
  icon?: string | undefined;
  subNav: SubNavItem[];
}

export function isRouteHandle(handle: unknown): handle is RouteHandle {
  return (
    typeof handle === 'object' &&
    handle !== null &&
    ('label' in handle || 'title' in handle || 'protected' in handle)
  );
}
